import { render, staticRenderFns } from "./testItemManage.vue?vue&type=template&id=b70af940&scoped=true"
import script from "./testItemManage.vue?vue&type=script&lang=js"
export * from "./testItemManage.vue?vue&type=script&lang=js"
import style0 from "./testItemManage.vue?vue&type=style&index=0&id=b70af940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70af940",
  null
  
)

export default component.exports